/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APINotification } from '@/models/api/notification.model'

const resource = {
    main: 'services',
    module: 'notifications'
}

export class NotificationsServices {
    public static getNotifications () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getNotificationsPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static editNotifications (params: APINotification) {
        return service.put(`${resource.main}/${resource.module}/${params.notificationId}`, params)
    }
}
